import type { ReactNode } from 'react';
import { styled } from '@mui/material/styles';

type Props = Readonly<{
  'data-test-id'?: string;
  children: ReactNode;
}>;

const StyledLexicalDialogActions = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'right',
  marginTop: '20px',
});

export const LexicalDialogActions = ({ 'data-test-id': dataTestId, children }: Props): JSX.Element => {
  return <StyledLexicalDialogActions data-test-id={dataTestId}>{children}</StyledLexicalDialogActions>;
};
